var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"waterfall",staticClass:"cz-waterfall",on:{"scroll":function($event){return _vm.scrollFun($event)}}},[_c('div',{ref:"waterfallBox",staticClass:"cz-waterfall-box"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }